import { Component, Input, OnChanges } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { RouterLink } from '@angular/router'
import { DataMap } from '@grapecity/wijmo.grid'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, EquipmentBattery, Grid, ListItem, ModalSize } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { EquipmentBatteryModalComponent } from './equipment-battery-modal.component'
import { PartsFluidsEquipmentContext } from './parts-fluids-equipment-context'

@Component({
    selector: 'app-equipment-battery-list',
    templateUrl: './equipment-battery-list.component.html',
    standalone: true,
    imports: [
        FormsModule,
        RouterLink,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        WjGridModule,
        WjGridFilterModule,
        AutoSizeDirective,
    ],
})
export class EquipmentBatteryListComponent extends BaseComponent implements OnChanges {
    @Input() canEdit = false
    @Input() equipmentOptions: ListItem<string>[] = []
    @Input() equipmentDataMap!: DataMap
    @Input() allItems: EquipmentBattery[] = []
    @Input() parent!: PartsFluidsEquipmentContext

    grid: Grid<EquipmentBattery>

    constructor() {
        super()
        this.grid = new Grid<EquipmentBattery>(this.services, 'equipment', this)
            .setupModalEditing(
                this.services.data.equipmentBatteries,
                'Battery',
                EquipmentBatteryModalComponent,
                () => {
                    const item = new EquipmentBattery()
                    item.id = crypto.randomUUID()
                    return item
                },
                this,
                ModalSize.medium,
            )
            .filterBy(item => [item.equipment, item.batterySizeGroup, item.notes])
    }

    ngOnChanges() {
        this.grid.items = this.allItems
    }
}
